import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PAGE_SIZE } from '../../constants';
import { useGetEvaluationCriteriaGroupsQuery } from './evaluationCriteriaGroupApiSlice';
import { useBreakpoint } from '../../hooks/useBreakpoint';
import { shortDate } from '../chat_sessions/MobileChatSessionList';
import { ChipRow, Dash, ListPageShell, ListPagination, ListTable } from '../../components/listPage';

/** 평가 항목 그룹. A row opens the group's own page (/evaluationcriteriagroups/:id); the side
 *  pane it replaced split the screen in half for a three-row table. */
const EvaluationCriteriaGroupList = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isMobile } = useBreakpoint();
  const queryParams = new URLSearchParams(location.search);
  const page = Number(queryParams.get('page') || 1);
  const page_size = Number(queryParams.get('page_size') || PAGE_SIZE);
  const { data, isLoading } = useGetEvaluationCriteriaGroupsQuery({ page, page_size });

  return (
    <ListPageShell isMobile={isMobile} icon="tasks" title="평가 항목 그룹" subtitle="응대 스킬 평가에 쓰는 평가 항목 묶음">
      <ChipRow groups={[]} count={data?.count} />
      <ListTable
        isMobile={isMobile}
        loading={isLoading}
        rows={data?.results || []}
        empty="평가 항목 그룹이 없습니다."
        onRowClick={g => navigate(`/evaluationcriteriagroups/${g.id}`)}
        columns={[
          { key: 'name', label: '그룹 이름', nowrap: true, render: g => <span style={{ fontWeight: 600 }}>{g.name}</span> },
          { key: 'description', label: '설명', render: g => (g.info?.description ? <span style={{ color: '#424245' }}>{g.info.description}</span> : <Dash />) },
          { key: 'count', label: '항목 수', align: 'center', render: g => g.criteria.length },
          { key: 'created', label: '생성일', muted: true, render: g => shortDate(g.created_at) },
        ]}
        card={{
          title: g => g.name,
          meta: g => [`항목 ${g.criteria.length}개`, `생성 ${shortDate(g.created_at)}`],
          body: g => g.info?.description,
        }}
      />
      <ListPagination page={page} count={data?.count || 0} pageSize={page_size} onChange={pg => navigate(`/evaluationcriteriagrouplist?page=${pg}&page_size=${page_size}`)} />
    </ListPageShell>
  );
};

export default EvaluationCriteriaGroupList;
